// 使用本地存储插件，可以替换成其他的存储插件
import cache from '@/plugins/cache'

cache.init()
// 绑定state的改变值的方法，可以通过 store.commit(state.prop,value)
function bindMutation (module: any) {
  if (!module.state) return
  module.mutations = {
    ...module.mutations,
    ...new Proxy(module.state, {
      get (target, propKey) {
        return (state: any, payload: any) => {
          state[propKey] = payload
        }
      },
      // 过滤 全大写表示常量，常量不可设置mutation
      ownKeys (target) {
        return Object.keys(target).filter((key) => key !== key.toUpperCase())
      }
    })
  }
}

// 返回包含所有模块的数组
function everyStore (root: any) {
  const stores = [root]
  let i = 0
  while (i < stores.length) {
    const s = stores[i]
    if (s.modules) {
      Object.entries(s.modules).forEach(([prop, store]: [string, any]) => {
        store.name = s === root ? prop : `${s.name}_${prop}`
        stores.push(store)
      })
    }
    i++
  }
  return stores
}

// state改变后保存到本地
function persistState (modules: any, root: any) {
  //
  root.plugins.push((store: any) => {
    setState(store)
    store.subscribe(saveState)
  })
  //
  const local = modules.reduce((acc: any, v: any) => {
    if (!v.local) return acc
    let type: Record<string, unknown> = {}
    if (v.namespaced) {
      Object.entries(v.local).forEach(([k, val]) => {
        type[`${v.name}/${k}`] = val
      })
    } else {
      type = v.local
    }
    return Object.assign(acc, type)
  }, {})
  //
  function setState (store: any) {
    Object.keys(local).forEach((key) => {
      // 不可用 mutation 修改
      key.split('/').reduce((state, v, i, arr) => {
        if (i === arr.length - 1) {
          state[v] = cache.get(key) ?? state[v]
        }
        return state[v]
      }, store.state)
    })
  }
  function saveState ({ type, ...rest }: { type: string }, state: any) {
    // 过滤 目前type只支持同名mutation，之后可以设置过滤函数属性
    if (type in local) {
      const expire = local[type]
      const val = type.split('/').reduce((state, v) => state[v], state)
      if (typeof expire === 'number') {
        // expire 是相对时间，cache保存的是绝对时间
        cache.set(type, val, Date.now() + expire)
      } else if (expire) {
        cache.set(type, val)
      }
    }
  }
}

//
export default (root: any) => {
  const modules = everyStore(root)
  return {
    root,
    modules,
    bindMutation () {
      modules.forEach(bindMutation)
      return this
    },
    persistState () {
      persistState(modules, root)
      return this
    }
  }
}
// 测试提交回滚
// 测试提交回滚2
